export default "__VITE_ASSET__f5ab1114__"